import { Reveal } from "./motion";
import { Plus } from "lucide-react";

const ITEMS = [
  "in-person mornings, two to three times a month, september through december",
  "a focused work hour to move your project forward",
  "guidance and prompts each time",
  "accountability and focused goal setting",
  "community building and collaboration",
  "access to our whatsapp community for support and sisterhood between gatherings, once you've come in person",
  "an onboarding kit when you join: who i am, what to expect, the prompts, tools to get clear, and a welcome gift",
  "the celebration party",
];

export const Included = () => (
  <section id="included" data-testid="included" className="bg-oat px-5 sm:px-8 lg:px-12 py-24 sm:py-32">
    <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12">
      <div className="lg:col-span-4">
        <Reveal>
          <span className="text-xs sm:text-sm font-semibold uppercase tracking-[0.24em] text-mushroom-deep">
            what's included
          </span>
          <h2 className="mt-4 font-display font-black lowercase tracking-tighter leading-[0.9] text-4xl sm:text-5xl lg:text-6xl">
            all of this, every month
          </h2>
        </Reveal>
      </div>
      <ul className="lg:col-span-8 divide-y divide-ink/15 border-t border-ink/15">
        {ITEMS.map((item, i) => (
          <Reveal key={i} delay={i * 0.05}>
            <li className="flex gap-4 sm:gap-6 py-6 items-start">
              <Plus className="w-5 h-5 sm:w-6 sm:h-6 mt-1 shrink-0 text-mushroom-deep" strokeWidth={2.5} />
              <span className="text-lg sm:text-2xl font-medium leading-[1.2] text-ink/90">{item}</span>
            </li>
          </Reveal>
        ))}
      </ul>
    </div>
  </section>
);
